import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KImageWidgetAnimationType } from './index.props.js';

var PREFIX = "KImageWidget";
var classes = {
    img: "".concat(PREFIX, "-img"),
    imgCover: "".concat(PREFIX, "-imgCover")
};
var StyledKImageWidget = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "animationType"; }
})(function (_a) {
    var _b;
    var animationType = _a.animationType;
    return (_b = {
            minHeight: "100%",
            display: "flex",
            position: "relative",
            width: "100%"
        },
        _b["& .".concat(classes.img)] = __assign({ maxWidth: "100%" }, (animationType === KImageWidgetAnimationType.ZoomOnHover && {
            overflow: "hidden",
            img: {
                transition: "all 250ms ease-out",
                scale: "1",
                verticalAlign: "bottom",
                "&:hover": {
                    "-ms-transform": "scale(1.1)",
                    "-webkit-transform": "scale(1.1)",
                    transform: "scale(1.1)"
                }
            }
        })),
        _b["& .".concat(classes.imgCover)] = {
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            height: "100%",
            width: "100%",
            objectFit: "cover",
            objectPosition: "center center"
        },
        _b);
});

export { classes, StyledKImageWidget as default };
//# sourceMappingURL=index.styled.js.map
